import React, { useCallback } from 'react';

//For when a component is used multiple places, with different headings required
const useHeadings = (topLevel: 'h1' | 'h2' | 'h3') => {
  const top = useCallback((props) => React.createElement(topLevel, props, props.children), [topLevel]);
  const sub = useCallback(
    (props) => React.createElement(`h${parseInt(topLevel.slice(1)) + 1}`, props, props.children),
    [topLevel],
  );

  return {
    TopLevel: top,
    SubLevel: sub,
  };
};

export default useHeadings;
